import React from "react";
import { useTranslation } from "react-i18next";
import { CustomInput } from "./CustomInput";
import { CharacterCounter } from "./CharacterCounter";

interface NewFolderFormProps {
  control: any;
  value: string;
  onValueChange: (value: string) => void;
  maxLength?: number;
  title?: string;
  label?: string;
  placeholder?: string;
}

export const NewFolderForm: React.FC<NewFolderFormProps> = ({
  control,
  value,
  onValueChange,
  maxLength = 50,
  title,
  label,
  placeholder,
}) => {
  const { t } = useTranslation();

  return (
    <div className="bg-white border border-gray-200 rounded-lg p-6">
      <h3 className="font-semibold text-gray-900 text-lg mb-4">
        {title || t("common.createNewFolder")}
      </h3>
      <CustomInput
        name="newKeyName"
        control={control}
        label={label || (t("common.folderName") as string)}
        placeholder={
          placeholder || (t("common.folderNamePlaceholder") as string)
        }
        onValueChange={(e) => onValueChange(e.target.value)}
        maxLength={maxLength}
      />
      <CharacterCounter
        currentLength={value?.length || 0}
        maxLength={maxLength}
      />
      <p className="text-xs text-gray-500 mt-1 mb-2">
        {t("common.folderNameHint")}
      </p>
    </div>
  );
};

export default NewFolderForm;
